/* eslint-disable */
import request from '@/utils/request'
import axios from 'axios'
// import defaultSettings from '@/settings'
import qs from 'qs'
import { getToken, setToken } from '@/utils/auth'
import * as msal from "@azure/msal-browser";
import { appStore } from '@/stores/app';
// import { userStore } from '@/stores/user';

console.log('path', window.location.origin, 'env', process.env.VUE_APP_AUTH_API)

const AAD_GLOBAL_JTRA_ID = "252c67cf-2e96-421e-abb4-77d56bb742ae";
const AAD_GLOBAL_AUTHORITY = 'https://login.microsoftonline.com/organizations/';
const AAD_CHINA_JTRA_ID = "5cc48130-70b4-4199-933b-35ef1ada5cf2"; 
const AAD_CHINA_AUTHORITY = 'https://login.partner.microsoftonline.cn/organizations/';
const FULL_BASE_URL = `${window.location.origin}${process.env.BASE_URL}`

// const JT_AUTH_API = "https://jtra-test.jingtengtech.com:3000/api/";


export async function loginWithPassword(username, password, clientId, authcode)
{  
  const params = new URLSearchParams();
  params.append('client_id', clientId);
  params.append('username', username);
  params.append('password', password);
  params.append('grant_type', 'password');

  if (authcode){
    params.append('authcode', authcode);
  }

  try{

    const { data } = await axios.post(`${process.env.VUE_APP_AUTH_API}/api/token`, params)

    console.log('server retruned: ', data);
  // request.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`

    return data;
  }
  catch(e){
    return Promise.reject(e.response.data)
  }

}

export async function refreshAccessToken(refreshToken) {
  const params = {
    client_id: defaultSettings.appGuid,
    grant_type: "refresh_token",
    refresh_token: refreshToken,
  };
  try {
    console.log("get refreshAccessToken", params);
    const instance = axios.create({
      baseURL: process.env.VUE_APP_AUTH_API, // defaultSettings.loginServer,//'https://account.jingtengtech.com', // url = base url + request url
      // withCredentials: true, // send cookies when cross-domain requests
      timeout: 5000 // request timeout
    })

    const result = await instance({
      url: "/api/token",
      method: "post",
      data: qs.stringify(params),
    });
    
    if (result) {
      return result.data
    }


  } catch (e) {
    return Promise.reject(e);
  }
}


export async function loginwithAadToken(idToken, clientAppId)
{
  const data = await request.post(`${process.env.VUE_APP_AUTH_API}/api/aadLogin`, {
    idToken,
    clientAppId
  });

  console.log('server retruned: ', data);
  return data;

}


export async function loginAadGlobal(clientId){

  const msalConfig = {
    auth: {
        clientId: AAD_GLOBAL_JTRA_ID,
        authority: AAD_GLOBAL_AUTHORITY,
        redirectUri: `${FULL_BASE_URL}login`,
    },
    cache: {
        cacheLocation: 'sessionStorage'
    }
  };

  console.log("msalConfig", msalConfig);

  const msalInstance = new msal.PublicClientApplication(msalConfig);

  const loginRequest = {
      scopes: ['openid', 'profile', 'offline_access']
  }

  try
  {
    const { idToken } = await msalInstance.loginPopup(loginRequest);
    console.log(`idToken ${idToken}`, clientId);

    const result = await loginwithAadToken(idToken, clientId);
    console.log('result', result)
    setToken(result.accessToken);
    // this.$router.push({name: 'code', params: { token, clientId: this.clientId }});

  }
  catch(err)
  {
    console.log('failed to login AAD global');
  }
  
}

export async function loginAadChina(clientId){

  const msalConfig = {
    auth: {
        clientId: AAD_CHINA_JTRA_ID,
        authority: AAD_CHINA_AUTHORITY,
        redirectUri: `${FULL_BASE_URL}login`,
    },
    cache: {
        cacheLocation: 'sessionStorage'
    }
  };

  const msalInstance = new msal.PublicClientApplication(msalConfig);

  const loginRequest = {
      scopes: ['openid', 'profile', 'offline_access']
  }

  try
  {
    const { idToken } = await msalInstance.loginPopup(loginRequest);
    console.log(`idToken ${idToken}`);

    const result = await loginwithAadToken(idToken, clientId);
    setToken(result.accessToken);
    // 

  }
  catch(err)
  {
    console.log('failed to login AAD China');
    return Promise.reject('failed to login AAD China')
  }

}
/*
export async function login(data) {
  const params = {
    username: data.username,
    password: data.password,
    grant_type: 'password',
    client_id: defaultSettings.appGuid,
    authcode: data.authcode
  }
  try {
    const instance = axios.create({
      baseURL: process.env.VUE_APP_AUTH_API, 
      timeout: 5000 // request timeout
    })
    console.log('params', data, params)
    const result = await instance({
      url: '/api/token',
      method: 'post',
      data: qs.stringify(params)
    })
    const token = result.data.accessToken
    result.data.token = token
    // console.log('token:', token);
    request.defaults.headers.common['Authorization'] = `Bearer ${token}`
    return result.data
  } catch (e) {
    // console.log('login err', e, e.response.data)
    return Promise.reject(e)
  }
}
*/
export function AuthenticateDevice(userCode, approved) {
  // console.log()
  return request.post(`${process.env.VUE_APP_AUTH_API}/api/authenticateDevice`,
    {
      userCode, approved
    }
  )
}

export function sendAuthCode(tel, username) {
  // console.log()
  return request.post(`${process.env.VUE_APP_AUTH_API}/api/sendAuthCode`,
    {
      tel, username
    }
  )
}

export function getUserInfo() {
  return request({
    url: `${process.env.VUE_APP_AUTH_API}/api/getMyUserInfo`,
    method: 'post'
  })
}

export function saveMyUser(displayName) {
  return request.post('/api/saveMyUser', { item: { displayName }})
}


export function checkTrialTelExists(tel) {
  return request.post('/api/trial/checkTrialTelExists',
    { tel })
}

export function regist(tel, authCode, newPass) {
  return request.post('/api/trial/createTrialUser',
    { tel, authCode, newPass, apps: [appStore().appGuid || process.env.VUE_APP_WORKFLOW_APPGUID] })
}

export function sendTrialAuthCode(tel) {
  return request.post('/api/trial/sendTrialAuthCode',
    { tel })
}


export function logout() {
}

export async function changePass(originPass, newPass) {
  try {
    const instance = axios.create({
      baseURL: process.env.VUE_APP_AUTH_API, // defaultSettings.loginServer,
      // withCredentials: true, // send cookies when cross-domain requests
      timeout: 5000
    })

    const token = getToken()
    if (token) {
      instance.defaults.headers.common['Authorization'] = `Bearer ${token}`

      await instance.post('/api/changePass', {
        originPass, newPass
      })

      return true
    } else {
      throw 'error'
    }
  } catch (e) {
    return Promise.reject(e)
  }
}

